import { render } from "./ButtonCustom.vue?vue&type=template&id=177e7153&scoped=true"
import script from "./ButtonCustom.vue?vue&type=script&lang=js"
export * from "./ButtonCustom.vue?vue&type=script&lang=js"

import "./ButtonCustom.vue?vue&type=style&index=0&id=177e7153&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-177e7153"]])

export default __exports__